const About = () => {
  return (
    <section id="about" className="py-24 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-light text-white text-center mb-16">
          About Me
        </h2>

        <div className="max-w-4xl mx-auto">
          {/* Main About Card */}
          <div className="border border-gray-800 rounded-2xl p-8 sm:p-12 backdrop-blur-sm bg-white/[0.02] space-y-6">
            
            <p className="text-gray-300 text-base sm:text-lg font-light leading-relaxed">
              I&apos;m <span className="text-white font-medium">Nadishan Danthanarayana</span>, 
              a passionate Full Stack Developer and founder of{" "}
              <span className="text-white">Neuro Corporation</span>.
              I specialize in building modern websites, mobile applications,
              SaaS platforms, AI-powered systems, and business automation tools.
            </p>

            <p className="text-gray-300 text-base sm:text-lg font-light leading-relaxed">
              My expertise includes React, Next.js, Flutter, Firebase,
              Node.js, TailwindCSS, Supabase, and cloud-based technologies.
              I focus on creating scalable, high-performance, and visually
              clean digital products that help businesses grow online.
            </p>

            <p className="text-gray-300 text-base sm:text-lg font-light leading-relaxed">
              I have worked on business websites, admin dashboards,
              eCommerce systems, AI tools, mobile applications,
              portfolio websites, and startup products for clients worldwide.
              I continuously learn emerging technologies to stay ahead in the
              modern software industry.
            </p>

            <p className="text-gray-300 text-base sm:text-lg font-light leading-relaxed">
              Beyond development, I&apos;m highly interested in artificial intelligence,
              automation systems, startup innovation, and building future-focused
              software products that create real impact.
            </p>
          </div>

          {/* Info Cards */}
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

            <div className="border border-gray-800 rounded-2xl p-6 sm:p-8 bg-white/[0.02] hover:border-gray-700 transition-all duration-300">
              <h3 className="text-white text-lg font-medium mb-3">
                Education
              </h3>

              <p className="text-gray-400 text-sm font-light leading-relaxed">
                Deniya Central College - Technology Stream.
                Self-taught via FreeCodeCamp, HubSpot & Google.
              </p>
            </div>

            <div className="border border-gray-800 rounded-2xl p-6 sm:p-8 bg-white/[0.02] hover:border-gray-700 transition-all duration-300">
              <h3 className="text-white text-lg font-medium mb-3">
                Experience
              </h3>

              <p className="text-gray-400 text-sm font-light leading-relaxed">
                Building web & mobile apps, client projects, SaaS platforms,
                Firebase backends, and AI-integrated tools.
              </p>
            </div>

            <div className="border border-gray-800 rounded-2xl p-6 sm:p-8 bg-white/[0.02] hover:border-gray-700 transition-all duration-300">
              <h3 className="text-white text-lg font-medium mb-3">
                Focus
              </h3>

              <p className="text-gray-400 text-sm font-light leading-relaxed">
                Full Stack Development, AI Automation, SaaS Platforms,
                Mobile Apps, Business Systems & Future Tech Innovation.
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;